import { json } from "@sveltejs/kit";
import { t as taskManager } from "../../../../../../chunks/task-manager.js";
const GET = async ({ params, url }) => {
  try {
    const taskId = params.id;
    const lastLine = parseInt(url.searchParams.get("lastLine") || "0");
    const result = taskManager.getTaskOutput(taskId, lastLine);
    return json(result);
  } catch (error) {
    console.error("Failed to get task output:", error);
    return json({ error: error.message }, { status: 500 });
  }
};
export {
  GET
};
